import React from "react";
import OtpInput from "react-otp-input";
import CoreInput from "./CoreInput";
import { Box } from "@mui/material";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";
import CoreFormHelperText from "../dataDisplay/CoreFormHelperText";

export default function CoreOtpInput(props) {
  const { id, formikProps } = props;

  return (
    <Box>
      <OtpInput
        containerStyle={{
          display: "flex",
        }}
        inputStyle={{
          width: "100%",
          margin: 8,
          border: "none",
          outline: "none",
          borderBottomStyle: "solid",
          borderBottomWidth: "none",
          fontSize: "2rem",
        }}
        id={props.id}
        name={props.id}
        value={props.value}
        onChange={props.onChange}
        numInputs={6}
        separator={<span></span>}
        shouldAutoFocus={props.autoFocus ? true : false}
        renderInput={(props) => <input {...props} autoComplete="off" aria-autocomplete="none"/>}
      />
      <CoreFormHelperText error>
        {formikProps?.touched[id] && formikProps?.errors[id]}
      </CoreFormHelperText>
    </Box>
  );
}
